import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button.jsx';
import { IoStar, IoSparkles, IoArrowForward, IoCheckmark } from 'react-icons/io5';
import '../styles/Pricing.css';

const templateFeatures = [
  'Choose from 12 ready-made designs',
  'Personalized with your details',
  'Interactive RSVP form included',
  'Shareable link for easy distribution',
  'Mobile-friendly responsive design',
  'Fast delivery (24–48 hours)',
];

const customFeatures = [
  'Fully custom design from scratch',
  'Up to 10 revisions',
  'Unique design tailored to your theme',
  'Premium animations & effects',
  'Priority support & consultation',
  'Fast delivery (24hrs – 3 days)',
];

const Pricing = () => {
  return (
    <div className="pricing-page">
      {/* Hero */}
      <section className="pp-hero">
        <h1>Affordable Pricing</h1>
        <p>Quality digital invitations that fit any budget — no hidden fees.</p>
      </section>

      {/* Cards */}
      <section className="pp-cards">
        {/* Template */}
        <div className="pp-card">
          <div className="pp-card-header">
            <span className="pp-type">Template Designs</span>
            <div className="pp-amount">
              <span className="pp-currency">₱</span>
              <span className="pp-price">200</span>
            </div>
            <span className="pp-note">Starting price · Choose from ready-made designs</span>
          </div>

          <div className="pp-features">
            <h4>What's Included:</h4>
            <ul>
              {templateFeatures.map((f, i) => (
                <li key={i}>
                  <IoCheckmark className="pp-check" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          <Link to="/invitations" className="pp-cta-link">
            <Button variant="outline-primary" size="large" className="pp-btn">
              Browse Templates
            </Button>
          </Link>
        </div>

        {/* Custom */}
        <div className="pp-card pp-card--featured">
          <div className="pp-badge">
            <IoSparkles className="pp-badge-icon" />
            <span>Most Popular</span>
          </div>

          <div className="pp-card-header">
            <span className="pp-type">Custom Designs</span>
            <div className="pp-amount">
              <span className="pp-currency">₱</span>
              <span className="pp-price">350</span>
              <span className="pp-sep">–</span>
              <span className="pp-currency">₱</span>
              <span className="pp-price">700</span>
            </div>
            <span className="pp-note">Unique design made just for you</span>
          </div>

          <div className="pp-features">
            <h4>What's Included:</h4>
            <ul>
              {customFeatures.map((f, i) => (
                <li key={i}>
                  <IoCheckmark className="pp-check pp-check--gold" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          <Link to="/book" className="pp-cta-link">
            <Button variant="primary" size="large" className="pp-btn">
              Book Custom Design
              <IoArrowForward className="pp-btn-icon" />
            </Button>
          </Link>
        </div>
      </section>

      {/* Payment terms */}
      <section className="pp-terms">
        <div className="pp-terms-inner">
          <span className="pp-terms-icon">💳</span>
          <div>
            <strong>Payment Terms:</strong> 50% downpayment upon booking.
            Remaining 50% is due once the design is completed and approved by you.
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="pp-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="pp-faq-grid">
          {[
            {
              q: 'How do I get started?',
              a: 'Fill out the booking form and our team will contact you via Messenger within 24 hours.',
            },
            {
              q: 'What payment methods do you accept?',
              a: 'GCash, Maya, bank transfer, and cash — details are sent via Messenger after booking.',
            },
            {
              q: 'Can I request revisions?',
              a: 'Template designs include minor text/detail edits. Custom designs include up to 10 revisions.',
            },
            {
              q: 'How long does it take?',
              a: 'Template designs: 24–48 hours. Custom designs: 24 hours to 3 days depending on complexity.',
            },
          ].map((item, i) => (
            <div key={i} className="pp-faq-item">
              <h4>{item.q}</h4>
              <p>{item.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="pp-cta">
        <h2>Ready to get started?</h2>
        <p>Book now and we'll reach out within 24 hours.</p>
        <Link to="/book">
          <Button variant="primary" size="large">
            Book Your Invitation
            <IoArrowForward className="pp-btn-icon" />
          </Button>
        </Link>
      </section>
    </div>
  );
};

export default Pricing;
